import { QuestionCategory, QuestionType } from "@/api/user/useGetMyQuestions";
import { QuestionnaireFlowQuestion } from "@/types/question.types";

export const hardcodedPersonalInfoQuestions: QuestionnaireFlowQuestion[] = [
  {
    slug: "gender",
    category: QuestionCategory.PERSONAL_INFO,
    type: QuestionType.SELECT_SINGLE,
    title: "성별을 선택해주세요",
    extra: {
      options: [
        { value: "FEMALE", displayText: "여성" },
        { value: "MALE", displayText: "남성" },
        { value: "NON_BINARY", displayText: "논바이너리" },
      ],
    },
  },
  {
    slug: "groupGenderPreference",
    category: QuestionCategory.PERSONAL_INFO,
    type: QuestionType.SELECT_SINGLE,
    title: "선호하는 모임 성별 구성은?",
    extra: {
      options: [
        { value: "ALL_GENDERS_OKAY", displayText: "모두 좋아요" },
        { value: "SAME_GENDER_PREFERRED", displayText: "같은 성별을 선호해요" },
      ],
    },
  },
  {
    slug: "maritalStatus",
    category: QuestionCategory.PERSONAL_INFO,
    type: QuestionType.SELECT_SINGLE,
    title: "현재 연애 상태는 어떤가요?",
    extra: {
      options: [
        { value: "SINGLE", displayText: "❤️ 싱글" },
        { value: "MARRIED", displayText: "💍 결혼" },
        { value: "RELATIONSHIP", displayText: "💑 연애 중" },
        { value: "COMPLICATED", displayText: "🌀 복잡해요" },
        { value: "NO_ANSWER", displayText: "🤐 답변 생략" },
      ],
    },
  },
  {
    slug: "hasChildren",
    category: QuestionCategory.PERSONAL_INFO,
    type: QuestionType.SELECT_SINGLE,
    title: "자녀가 있으신가요?",
    extra: {
      options: [
        { value: "YES", displayText: "👶 있어요" },
        { value: "NO", displayText: "🙅 없어요" },
        { value: "NO_ANSWER", displayText: "🤐 답변 생략" },
      ],
    },
  },
  {
    slug: "profession",
    category: QuestionCategory.PERSONAL_INFO,
    type: QuestionType.SELECT_SINGLE,
    title: "직업은 어떤 분야인가요?",
    extra: {
      options: [
        { value: "IT", displayText: "IT" },
        { value: "ART", displayText: "예술" },
        { value: "MEDICAL", displayText: "의료" },
        { value: "PUBLIC", displayText: "정치/공공" },
        { value: "FNB", displayText: "요식업" },
        { value: "BUSINESS", displayText: "사업" },
        { value: "FINANCE", displayText: "금융" },
        { value: "ETC", displayText: "기타" },
      ],
    },
  },
  {
    slug: "nationality",
    category: QuestionCategory.PERSONAL_INFO,
    type: QuestionType.SELECT_FROM_LIST,
    title: "어느 나라 출신이신가요?",
    extra: {
      options: [
        { displayText: "대한민국" },
        { displayText: "가나" },
        { displayText: "가봉" },
        { displayText: "가이아나" },
        { displayText: "감비아" },
        { displayText: "과테말라" },
        { displayText: "그레나다" },
        { displayText: "그리스" },
        { displayText: "기니" },
        { displayText: "기니비사우" },
        { displayText: "나미비아" },
        { displayText: "나이지리아" },
        { displayText: "남수단" },
        { displayText: "남아프리카 공화국" },
        { displayText: "네덜란드" },
        { displayText: "네팔" },
        { displayText: "노르웨이" },
        { displayText: "뉴질랜드" },
        { displayText: "니제르" },
        { displayText: "니카라과" },
        { displayText: "대만" },
        { displayText: "덴마크" },
        { displayText: "도미니카 공화국" },
        { displayText: "도미니카 연방" },
        { displayText: "독일" },
        { displayText: "동티모르" },
        { displayText: "라오스" },
        { displayText: "라트비아" },
        { displayText: "러시아" },
        { displayText: "레바논" },
        { displayText: "레소토" },
        { displayText: "루마니아" },
        { displayText: "룩셈부르크" },
        { displayText: "르완다" },
        { displayText: "리비아" },
        { displayText: "리투아니아" },
        { displayText: "리히텐슈타인" },
        { displayText: "마다가스카르" },
        { displayText: "마셜 제도" },
        { displayText: "마케도니아" },
        { displayText: "말라위" },
        { displayText: "말레이시아" },
        { displayText: "말리" },
        { displayText: "멕시코" },
        { displayText: "모나코" },
        { displayText: "모로코" },
        { displayText: "모리셔스" },
        { displayText: "모리타니" },
        { displayText: "모잠비크" },
        { displayText: "몬테네그로" },
        { displayText: "몰도바" },
        { displayText: "몰디브" },
        { displayText: "몰타" },
        { displayText: "몽골" },
        { displayText: "미국" },
        { displayText: "미얀마" },
        { displayText: "바누아투" },
        { displayText: "바레인" },
        { displayText: "바베이도스" },
        { displayText: "바티칸" },
        { displayText: "바하마" },
        { displayText: "방글라데시" },
        { displayText: "버뮤다" },
        { displayText: "베냉" },
        { displayText: "베네수엘라" },
        { displayText: "베트남" },
        { displayText: "벨기에" },
        { displayText: "벨라루스" },
        { displayText: "벨리즈" },
        { displayText: "보스니아 헤르체고비나" },
        { displayText: "보츠와나" },
        { displayText: "볼리비아" },
        { displayText: "부룬디" },
        { displayText: "부르키나파소" },
        { displayText: "부탄" },
        { displayText: "북마케도니아" },
        { displayText: "불가리아" },
        { displayText: "브라질" },
        { displayText: "브루나이" },
        { displayText: "사모아" },
        { displayText: "사우디아라비아" },
        { displayText: "산마리노" },
        { displayText: "상투메 프린시페" },
        { displayText: "세네갈" },
        { displayText: "세르비아" },
        { displayText: "세이셸" },
        { displayText: "세인트루시아" },
        { displayText: "세인트빈센트 그레나딘" },
        { displayText: "세인트키츠 네비스" },
        { displayText: "소말리아" },
        { displayText: "솔로몬 제도" },
        { displayText: "수단" },
        { displayText: "수리남" },
        { displayText: "스리랑카" },
        { displayText: "스웨덴" },
        { displayText: "스위스" },
        { displayText: "스페인" },
        { displayText: "슬로바키아" },
        { displayText: "슬로베니아" },
        { displayText: "시리아" },
        { displayText: "시에라리온" },
        { displayText: "싱가포르" },
        { displayText: "아랍에미리트" },
        { displayText: "아르메니아" },
        { displayText: "아르헨티나" },
        { displayText: "아이슬란드" },
        { displayText: "아이티" },
        { displayText: "아일랜드" },
        { displayText: "아제르바이잔" },
        { displayText: "아프가니스탄" },
        { displayText: "안도라" },
        { displayText: "알바니아" },
        { displayText: "알제리" },
        { displayText: "앙골라" },
        { displayText: "앤티가 바부다" },
        { displayText: "에리트레아" },
        { displayText: "에스토니아" },
        { displayText: "에스와티니" },
        { displayText: "에콰도르" },
        { displayText: "에티오피아" },
        { displayText: "엘살바도르" },
        { displayText: "영국" },
        { displayText: "예멘" },
        { displayText: "오만" },
        { displayText: "오스트리아" },
        { displayText: "온두라스" },
        { displayText: "요르단" },
        { displayText: "우간다" },
        { displayText: "우루과이" },
        { displayText: "우즈베키스탄" },
        { displayText: "우크라이나" },
        { displayText: "이라크" },
        { displayText: "이란" },
        { displayText: "이스라엘" },
        { displayText: "이집트" },
        { displayText: "이탈리아" },
        { displayText: "인도" },
        { displayText: "인도네시아" },
        { displayText: "일본" },
        { displayText: "자메이카" },
        { displayText: "잠비아" },
        { displayText: "적도 기니" },
        { displayText: "조지아" },
        { displayText: "중국" },
        { displayText: "중앙아프리카 공화국" },
        { displayText: "지부티" },
        { displayText: "짐바브웨" },
        { displayText: "차드" },
        { displayText: "체코" },
        { displayText: "칠레" },
        { displayText: "카메룬" },
        { displayText: "카보베르데" },
        { displayText: "카자흐스탄" },
        { displayText: "카타르" },
        { displayText: "캄보디아" },
        { displayText: "캐나다" },
        { displayText: "케냐" },
        { displayText: "코모로" },
        { displayText: "코스타리카" },
        { displayText: "코트디부아르" },
        { displayText: "콜롬비아" },
        { displayText: "콩고 공화국" },
        { displayText: "콩고 민주 공화국" },
        { displayText: "쿠바" },
        { displayText: "쿠웨이트" },
        { displayText: "크로아티아" },
        { displayText: "키르기스스탄" },
        { displayText: "키리바시" },
        { displayText: "키프로스" },
        { displayText: "타지키스탄" },
        { displayText: "탄자니아" },
        { displayText: "태국" },
        { displayText: "터키" },
        { displayText: "토고" },
        { displayText: "통가" },
        { displayText: "투르크메니스탄" },
        { displayText: "투발루" },
        { displayText: "튀니지" },
        { displayText: "트리니다드 토바고" },
        { displayText: "파나마" },
        { displayText: "파라과이" },
        { displayText: "파키스탄" },
        { displayText: "파푸아뉴기니" },
        { displayText: "팔라우" },
        { displayText: "팔레스타인" },
        { displayText: "페루" },
        { displayText: "포르투갈" },
        { displayText: "폴란드" },
        { displayText: "푸에르토리코" },
        { displayText: "프랑스" },
        { displayText: "피지" },
        { displayText: "핀란드" },
        { displayText: "필리핀" },
        { displayText: "헝가리" },
        { displayText: "호주" },
        { displayText: "홍콩" },
        { displayText: "기타", customInputType: "text_input" as const },
      ],
    },
  },
  {
    slug: "birthDate",
    category: QuestionCategory.PERSONAL_INFO,
    type: QuestionType.DATE,
    title: "생일이 언제이신가요?",
    extra: {},
  },
  {
    slug: "groupAgePreference",
    category: QuestionCategory.PERSONAL_INFO,
    type: QuestionType.SELECT_SINGLE,
    title: "선호하는 모임 나이대 구성은?",
    extra: {
      options: [
        { value: "ALL_AGES_OKAY", displayText: "모두 좋아요" },
        { value: "SAME_AGE_PREFERRED", displayText: "비슷한 나이대를 선호해요" },
      ],
    },
  },
];
